export const validation = {
  watch: {
    validation(value) {
      this.$emit('validation', value)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  }
}
